
angular.module('bmsApp.directives')
	.directive('leavingPromptResponseView', [
		function () {
			return {
				restrict: 'E',
				scope: {
					leavingPromptResponses: '=',
				},
				replace: true,
				templateUrl: 'ng/global/leaving-prompt-response/templates/LeavingPromptResponseView.html',
				link: function (scope, element, attrs) {
				},
				controller: function ($scope) {
				}
			};
		}]);
